<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Update Process Rates ({{ page_data.data?.lab_name }})</h2>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y box col-span-12 p-5">

        <!-- BEGIN: Form Layout -->
        <div class="">

          <table class="table border-2 pt-5">

            <thead>
              <tr class="border">
                <th>NO</th>
                <th>From</th>
                <th>To</th>
                <th>Rate</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody class="border">

              <tr class="" v-for="(item, index) in formData.data" :key="index">
                <td class="whitespace-nowrap border-b">{{ index + 1 }}</td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.from_ct"
                    class="form-control rounded-none w-full" placeholder="From" aria-describedby="input-group-3"
                    @keypress="$h.preventInvalidInput" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.to_ct"
                    class="form-control rounded-none w-full" placeholder="To" aria-describedby="input-group-3"
                    @keypress="$h.preventInvalidInput" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.rate"
                    class="form-control rounded-none w-full" placeholder="Rate" aria-describedby="input-group-3"
                    @keypress="$h.preventInvalidInput" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="index != 0">
                  <button class="btn btn-danger btn-sm py-2" @click="remove_column(item.id)">
                    <Trash2Icon class="h-4 w-4" />
                  </button>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        <div class="flex justify-between items-center">

          <div>
            <button class="btn btn-primary btn-sm p-2" @click="add_column">
              <PlusIcon class="h-4 w-4 mr-2" /> Add
            </button>
          </div>
          <div class="text-right mt-3">
            <router-link :to="{ name: 'jober-details' }" class="btn btn-outline-secondary w-24 mr-1">
              Cancel
            </router-link>
            <button type="button" @click="submit_form" :disabled="page_data.submit" class="btn btn-primary w-24">Save
              <LoadingIcon v-if="page_data.submit" icon="oval" color="white" class="w-4 h-4 ml-2" />
            </button>
          </div>

        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { BASE_URL } from '@/constants/config'
import router from '@/router'
import axios from 'axios'
import { defineComponent, inject, onMounted, reactive, ref, toRef, watch } from 'vue'
import Toastify from 'toastify-js'
import { useRoute } from 'vue-router'
import { stringify } from 'json5'
import Swal from 'sweetalert2'

const route = useRoute()
const swal = inject('$swal')
const page_data = reactive({
  item: [],
  column_index: 0,
  submit: false
})

const formData = reactive({
  lab_id: null,
  data: []
})
const add_column = () => {

  // console.log(formData.data);
  //       console.log(formData.data.length);

  page_data.column_index += 1;
  formData.data.push({
    id: page_data.column_index,
    from_ct: "",
    to_ct: "",
    rate: ""
  })
}

const remove_column = (id) => {
  swal({
    title: "Are you sure?",
    text: "You are about remove rate!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Delete",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      var i = formData.data.length;
      while (i--) {
        if (formData.data[i]['id'] == id) {
          formData.data.splice(i, 1);
        }
      }
    }
  });
}

const get_process_details = () => {

  let promise = axios({
    url: 'api/master/get_lab_rate_details?id=' + route.params.id,
    method: "GET",
    baseURL: BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    config: { headers: { Accept: "application/json" } }
  });
  return promise
    .then(result => result.data)
    .then(data => {

      if (data.success == false) {
        Swal.fire({
          html: data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        }).then(() => {
          return;
        });
      } else {

        page_data.data = data.data;

        let rates = page_data.data.lab_rates;

        formData.lab_id = page_data.data.id
        formData.data = [];

        for (let i = 0; i < rates.length; i++) {
          formData.data.push({
            id: rates[i].id,
            from_ct: rates[i].from_ct,
            to_ct: rates[i].to_ct,
            rate: rates[i].rate,
          });

          if (i == rates.length - 1) {
            page_data.column_index = rates[i].id
          }
        }

        if(formData.data.length == 0){
          add_column()
        }
      }

    }).catch(_error => {

      Swal.fire({
        html: "Something went wrong!",
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Try again!",
        heightAuto: false,
        customClass: {
          confirmButton: "btn fw-semobold btn-light-danger",
        },
      }).then(() => {
        return;
      })
    });
}

const submit_form = () => {
  page_data.submit = true;
  swal({
    title: "Are you sure?",
    text: "You are about update rates!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Save",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {


      let promise = axios({
        url: "api/master/set_lab_rate_details",
        method: "POST",
        data: formData,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        config: { headers: { Accept: "application/json" } }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          page_data.submit = false;
          if (data.success == false) {
            Swal.fire({
              html: data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              heightAuto: false,
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            }).then(() => {
              return;
            })
          } else {
            Swal.fire({
              html: data.message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              heightAuto: false,
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            }).then(() => {
              return;
            })
          }

        })
        .catch(_error => {
          page_data.submit = false;
          Swal.fire({
            html: "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          }).then(() => {
            return;
          })

        });
    }
  });
}

onMounted(() => {
  get_process_details()
})
</script>
